var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.1,
    height: 14,
    viewBox: "0 0 16.1 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34336",
    "data-name": "Path 34336",
    d: "M3.8,9A1.4,1.4,0,1,1,2.4,7.6,1.4,1.4,0,0,1,3.8,9M3.1,2V6.2H1.7V2H3.1M1.7,16V11.8H3.1V16H1.7M17.1,4.8v8.4a1.4,1.4,0,0,1-1.4,1.4H7.3a1.4,1.4,0,0,1-1.4-1.4V10.4L4.5,9,5.9,7.6V4.8A1.4,1.4,0,0,1,7.3,3.4h8.4a1.4,1.4,0,0,1,1.4,1.4m-1.4,0H7.3V8.181L6.481,9l.819.819V13.2h8.4V4.8m-7,2.1h5.6V8.3H8.7V6.9m0,2.8h4.2v1.4H8.7Z",
    transform: "translate(-1 -2)",
    fill: "#0071cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/Icon_Report.1b1da2b6648074bc50b0789b4d453435.svg";
export { ForwardRef as ReactComponent };